export const FETCHING_MY_CIRCLES = "FETCHING.CIRCLES.MY";
export const REQUESTING_CIRCLE = "REQUESTING.CIRCLE";
export const REQUESTED_CIRCLE = "REQUESTED.CIRCLE";
export const ERROR_REQUESTING_CIRCLE = "ERROR.REQUESTING_CIRCLE";
export const MARKING_PRODUCT_AS_BOUGHT = "MARKING.CIRCLES.BOUGHT";
export const FETCHED_MY_CIRCLES = "FETCHED.CIRCLES.MY";
export const MARKED_PRODUCT_AS_BOUGHT = "MARKED.CIRCLES.BOUGHT";
export const ERROR_FETCHING_MY_CIRCLES = "ERROR.FETCHING_MY_CIRCLES";
export const ERROR_MARKING_CIRCLES = "ERROR.MARKING_CIRCLES";

export const SAVING_CIRCLE_DETAILS = "SAVING.CIRCLE.DETAILS";
export const SAVED_CIRCLE_DETAILS = "SAVED.CIRCLE.DETAILS";
export const ERROR_SAVING_CIRCLE = "ERROR.SAVING_CIRCLE";

export const SEND_PUZZLE_REQUEST = "SEND_PUZZLE_REQUEST";
export const ERROR_REQUESTING_PUZZLE = "ERROR.REQUESTING_PUZZLE";
export const REQUESTING_PUZZLE = "REQUESTING_PUZZLE";

export const INVITING_FRIENDS = "INVITING_FRIENDS";
export const INVITED_FRIENDS = "INVITED_FRIENDS";
export const ERROR_INVITING_FRIENDS = "ERROR.INVITING_FRIENDS";

export const ERROR_MARKING_INTEREST = "ERROR.MARKING_INTEREST";
export const MARKED_INTEREST = "MARKED_INTEREST";
export const MARKING_INTEREST = "MARKING_INTEREST";

export const MIGRATING_MEMBERS_ERROR = "MIGRATING_MEMBERS_ERROR";
export const MIGRATING_MEMBERS = "MIGRATING_MEMBERS";

export const REMOVING_MEMBER = "REMOVING_MEMBER";
export const REMOVING_MEMBER_ERROR = "REMOVING_MEMBER_ERROR";
export const REMOVING_MEMBER_SUCCESS = "REMOVING_MEMBER_SUCCESS";

